import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Scholarshipleft({ activeIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>
                
                    <ListGroup>
                    <ListGroup.Item as={Link} action to="/institute-scholarships" className="mb-3 p-3">
                        <b>Scholarships Offered by the Institute</b>
                          </ListGroup.Item>
                    </ListGroup>
                    <ListGroup>
                        <ListGroup.Item as={Link} action to="/institute-scholarships" className={`p-3 ${activeIndex == 0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            UG Students 
                        </ListGroup.Item>
                        <ListGroup.Item as={Link} action to="/scholarships-for-pg-students" className={`p-3 ${activeIndex == 1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            PG Students 
                        </ListGroup.Item>
                        </ListGroup>
                        </Col>

                        <Col sm={12}>
                        <ListGroup>
                    <ListGroup.Item as={Link} action to="/national-scholarship-portal" className="mb-3 mt-3 p-3">
                        <b>Other Scholarships</b>
                          </ListGroup.Item>
                          </ListGroup>
                          <ListGroup>
                            <ListGroup.Item as={Link} action to="/national-scholarship-portal" className={`p-3 ${activeIndex == 2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            National Scholarship Portal (NSP) 
                        </ListGroup.Item>
                    <ListGroup.Item as={Link} action to="/pm-vidyalaxmi-scheme" className={`p-3 ${activeIndex == 3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            PM-Vidyalaxmi Scheme 
                        </ListGroup.Item>
                        

                    </ListGroup>
                    
                        </Col>
                        <Col sm={12}>
                        <ListGroup>
                    <ListGroup.Item as={Link} action to="/institute-aishe-code" className={`mb-3 mt-3 p-3 ${activeIndex == 4 ? " active" : ""}`}>
                            <b>
                            Institute AISHE Code </b>
                        </ListGroup.Item>
                        </ListGroup>
                </Col>
                {/* <Col sm={8}>
          <Tab.Content>
            <Tab.Pane eventKey="#link1">Tab pane content 1</Tab.Pane>
            <Tab.Pane eventKey="#link2">Tab pane content 2</Tab.Pane>
          </Tab.Content>
        </Col> */}
            </Row>
        </Tab.Container>
    );
}

export default Scholarshipleft;